/**
 * Image Tab
 */
import React from 'react'
import { Tab } from 'semantic-ui-react'
import util from '../../../../util/util'

import ImageScroller from '../ImageScroller'

const ScrollerTab = (props) => {
  const { images, subkey } = props.props

  return (
    <Tab.Pane className="image-tab" attached={false} key={subkey}>
      {props && (
        <div className="image">
          <ImageScroller images={images} />
        </div>
      )}
    </Tab.Pane>
  )
}

export default ScrollerTab
